//
import ProviderAccountBankModel from '@/models/Purchase/PchProviderAccountBank'

//
export default [
    {
        text: '#',
        value: 'debt_to_pays_pch_purchase_id',
        width: '1%',
    },
    {
        text: 'folio',
        value: 'debt_to_pays_pch_purchase_invoice_number',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
        component: {
            custom: 'pch_provider_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'provider-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle documento',
            },
        },
    },
    {
        text: 'cuenta',
        value: 'pch_provider_account_bank_account_number',
        input: {
            autoSelectFirst: true,
            custom: 'pch_provider_account_bank',
            model: ProviderAccountBankModel,
            itemText: 'account_number_bank',
            itemValue: 'id',
            label: 'Seleccionar cuenta de banco',
            noDataText: 'Sin cuentas de banco.',
            outline: false,
            paramSearch: 'pch_provider_id',
            renderFilter: row => ({
                pch_provider_id: row.item.pch_provider_id,
            }),
            trigger(ctx, props) {
                console.log(ctx, props)
            },
            type: 'autocomplete-model',
        },
        width: '20%',
    },
    {
        text: 'banco',
        fieldType: 'computed',
        value: 'pch_provider_account_bank_g_bank_bank',
        width: '15%',
    },
    {
        text: 'saldo',
        value: 'debt_to_pays_balance',
        align: 'right',
        format: 'currency',
        width: '12%',
    },
    {
        text: 'a pagar',
        value: 'amount_to_pay',
        align: 'right',
        format: 'currency',
        input: {
            reverse: true,
            type: 'currency-field',
        },
        width: '12%',
    },
]
